import { createReducer, on } from '@ngrx/store';
import { AemState } from '../../models/states/aem-state.interfaces';
import * as fromAemActions from '../actions/aem.actions';

export const AemStateKey = 'aem';

const initialState: AemState = {
  isReady: false,
  isError: false,
  bookWidgetAem: null
};

export const aemReducer = createReducer(
  initialState,
  on(fromAemActions.LoadBookWidgetAemSuccess, (state, { bookWidgetAem }) => ({
    ...state,
    isReady: true,
    isError: false,
    bookWidgetAem
  })),
  on(fromAemActions.LoadBookWidgetAemFailure, (state) => ({
    ...state,
    isReady: false,
    isError: true
  }))
);
